(function() {
  'use strict';

  angular.module('app').factory('PriceGroupsService', PriceGroupsService);

  PriceGroupsService.$inject = ['$rootScope', 'API'];

  function PriceGroupsService($rootScope, API) {
    var service = {};
    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */

    /**
     * Return list of price groups
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {object} params
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPriceGroups = function(loyaltyID, params, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups' + (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''),
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Get price group info
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPriceGroup = function(loyaltyID, priceGroupID, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Add price group
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {object} priceGroup
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddPriceGroup = function(loyaltyID, priceGroup, callback) {
      API.post('/loyalty/' + loyaltyID + '/price_groups', priceGroup, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Delete price group
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeletePriceGroup = function(loyaltyID, priceGroupID, callback) {
      API.delete('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID, null, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify price group info
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {object} priceGroup
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdatePriceGroup = function(loyaltyID, priceGroupID, priceGroup, callback) {
      API.patch('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID, priceGroup,
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPriceGroupTaxes = function(loyaltyID, priceGroupID, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/taxes', function(success, data) {
        callback(success, data);
      });
    };
    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {object} taxes
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdatePriceGroupTaxes = function(loyaltyID, priceGroupID, taxes, callback) {
      API.patch('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/taxes', taxes,
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {object[]} priceGroupItem
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdatePriceGroupsItems = function(loyaltyID, priceGroupID, priceGroupItem, callback) {
      API.patch('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items', priceGroupItem, function(success, data) {
        callback(success, data);
      });
    };
    /**
     * Delete goods items from price group
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeletePriceGroupsItems = function(loyaltyID, priceGroupID, callback) {
      API.delete('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items', null, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of goods items in the price group
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {object} params
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPriceGroupItems = function(loyaltyID, priceGroupID, params, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items' +
          (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''),
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {string} itemID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPriceGroupsItem = function(loyaltyID, priceGroupID, itemID, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items/' + itemID, function(success, data) {
        callback(success, data);
      });
    };
    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param priceGroupItem
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddPriceGroupsItem = function(loyaltyID, priceGroupID, priceGroupItem, callback) {
      API.post('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items', priceGroupItem, function(success, data) {
        callback(success, data);
      });
    };
    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {string} itemID
     * @param {object} priceGroupItem
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdatePriceGroupsItem = function(loyaltyID, priceGroupID, itemID, priceGroupItem, callback) {
      API.patch('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items/' + itemID, priceGroupItem, function(success, data) {
        callback(success, data);
      });
    };
    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {string} itemID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeletePriceGroupsItem = function(loyaltyID, priceGroupID, itemID, callback) {
      API.delete('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items/' + itemID, null, function(success, data) {
        callback(success, data);
      });
    };

    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {object} params
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetGoodsSelect = function(loyaltyID, priceGroupID, params, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/goods' +
          (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''),
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Return matrix axes data
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetMatrixAxes = function(loyaltyID, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/matrix/axes',
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Return matrix of goods items with last entered master price data
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetMatrixMasterPrices = function(loyaltyID, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/matrix/master_prices',
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param params
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetMatrixPrices = function(loyaltyID, params, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/matrix/prices' + (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''),
          function(success, data) {
            callback(success, data);
          });
    };
    /**
     * Return matrix of goods items with tax rates data
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetMatrixTaxRates = function(loyaltyID, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/matrix/tax_rates',
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Get goods item's master price change history
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {string} itemID - Loyalty item ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetMasterPricesHistory = function(loyaltyID, priceGroupID, itemID, callback) {
      API.get('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items/' + itemID + '/master_prices',
          function(success, data) {
            callback(success, data);
          });
    };
    /**
     * Delete goods item's master price
     *
     * @param {string} loyaltyID - Loyalty ID
     * @param {string} priceGroupID - Price group ID
     * @param {string} itemID - Loyalty item ID
     * @param {string} masterPriceID - Master price ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeleteMasterPricesHistory = function(loyaltyID, priceGroupID, itemID, masterPriceID, callback) {
      API.delete('/loyalty/' + loyaltyID + '/price_groups/' + priceGroupID + '/items/' + itemID + '/master_prices/' + masterPriceID, null,
          function(success, data) {
            callback(success, data);
          });
    };
    return service;
  }
})();
